import { type CloudpackConfig } from '@ms-cloudpack/config-types';

export interface BundleContext {
  config: CloudpackConfig;
  moduleType: 'cjs' | 'esm' | undefined;
}
